import "../../components/css/Button.css";

function Button({ text }) {
  return (
    <button className="cta-button">
      {text}
      <span>➜</span>
    </button>
  );
}

export default Button;
